import React, { ButtonHTMLAttributes } from 'react';
import Button from '../Button/Button';
import styles from './PhotoUploadButton.module.css';

interface PhotoUploadButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
}

const PhotoUploadButton: React.FC<PhotoUploadButtonProps> = ({
  className = '',
  children,
  type = 'button',
  ...rest
}) => {
  const classes = [styles.button, className].filter(Boolean).join(' ');

  return (
    <Button variant="secondary" size="small" className={classes} type={type} {...rest}>
      {children}
    </Button>
  );
};

export default PhotoUploadButton;